export default __webpack_public_path__ + "static/media/wwr-img.0b885bb0.webp";